import React from "react";
import * as Style from "./styles/collectibles-card";
// import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { postSetSelectedModuleName } from "../../../../redux/slices/inventorySlice";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function CollectiblesCard({ data, showCollectibleItems, count }) {
  console.log("data", data);
  const { image, name } = data;
  const history = useHistory();

  const dispatch = useDispatch();

  const handleCardClick = (name) => {
    dispatch(postSetSelectedModuleName(name));
    history.push({
      pathname: `/items/${name}`,
      //   search: name,
      // state: { detail: response.data }
    });
    // showCollectibleItems()
  };

  return (
    <React.Fragment>
      <div
        // key={index}
        onClick={() => handleCardClick(name)}
        className="selectMaincards"
      >
        <div className="selectMaincardsInner" style={{justifyContent:"space-between"}}>
          {" "}
          <div style={{display:"flex", flexWrap:"wrap", alignItems:"center"}}>
          <div className="selectMainImagesCollectable">
            <img src={image} style={{width: "100%", height: "100%", objectFit: "cover", }} alt={name} />{" "}
          </div>
          <div className="selectMainHeader">
            <span className="selectheadingValue">{name}</span>
          </div>
          </div>
          <div style={{display:"flex", flexWrap:"wrap", alignItems:"center"}}> 
          {
            count > 1 && `${count} Items`
          }
          {
            count === 1 && `${count} Item`
          }
          {
            count === 0 && null
          } 
          </div>
        </div>
      </div>

      {/*  <Style.MainContainer
        //   onClick={() => {
        //     // history.push("/items");
        //     history.push({
        //       pathname: "/items",
        //       moduleName: `${name}_item`,
        //       image:image
        //     });
        //   }}
        onClick={() => handleCardClick(name)}
      >
        <img
          src={
            image ||
            "https://assetplanet-dashboard.herokuapp.com/static/media/member.5d444ca9.png"
          }
          height="45px"
          width="45px"
        />

        <div style={{ fontSize: "1.1rem" }}>{name}</div>
        </Style.MainContainer>*/}
    </React.Fragment>
  );
}
export default CollectiblesCard;
